/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Self_Organize_Start_BtnInputs */



/**
* | output |
* | --- |
* | "Self-organize a round" |
*
* @param {Self_Organize_Start_BtnInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const self_organize_start_btn = /** @type {((inputs?: Self_Organize_Start_BtnInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Self_Organize_Start_BtnInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Auto-organiser une ronde")
	if (locale === "es") return /** @type {LocalizedString} */ ("Autoorganizar una ronda")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Auto-organizar uma rodada")
	if (locale === "it") return /** @type {LocalizedString} */ ("Autogestire un round")
	return /** @type {LocalizedString} */ ("Self-organize a round")
});